import React from 'react';
import ProcedureTab from './ProcedureTab';
import { PROCEDURE_CATEGORIES } from '../../types/ProcedureTypes';

interface CleaningTabProps {
    procedures: any[];
    loading: boolean;
    error: string | null;
    selectedProcedure: any;
    setSelectedProcedure: (procedure: any) => void;
    onRefresh?: () => void;
}

const CleaningTab: React.FC<CleaningTabProps> = (props) => {
    const config = {
        title: 'Cleaning Procedures',
        description: 'Tank cleaning procedures and guidelines',
        icon: 'fa-broom',
        category: PROCEDURE_CATEGORIES.CLEANING,
        columns: [
            {
                key: 'title',
                header: 'Title',
            },
        ],
    };

    return <ProcedureTab config={config} {...props} />;
};

export default CleaningTab;
